import { Toast } from 'antd-mobile';
import {
  DEFAULT_APPLY_FILTER,
  DEFAULT_FILTER_OPTIONS,
  DISPATCH_RANGE,
  DISPATCH_RANGE_OPTIONS,
  LIST_MODE,
  NAT_OPTIONS,
  NAT_TYPE,
  PAGE_SIZE,
} from '../config/pars';
import {
  postApply,
  getApplyResult,
  getFilter,
  getRecruitList,
  getRecruitBizRules,
  getRecruitBizTabs,
  getResultFilter,
  setBizTabRead,
  getBizFilterOptions,
  getBizInfoList, postReApply,
} from '../services';
import { BOX_INDEX_TAG, X86_INDEX_TAG } from '@/pages/recruit/direct/config/recruit.config';

export default {
  namespace: 'recruit',

  state: {
    bizRule: {},
    applyResList: [],
    // 申请提交回调结果
    applyResInfo: {
      total_num: 3,
      fail_num: 2,
      snlist: [],
    },
    // 提交申请的参数，暂存用于重新申请
    applyParms: {},
    // 提交申请的设备信息
    applyDeviceList: [],
    // 招募业务tabs
    // bizTabs: { recruitingList: [], finishRecruitList: [] },
    applyFilter: {
      ...DEFAULT_APPLY_FILTER,
    },
    deviceList: [],
    chooseCount: 0,
    isDeviceListAll: false,
    isCheckAll: false,
    resultFilter: [
      {
        id: '0',
        label: '全部',
      },
    ],
    isResultListAll: false,
    // x86上机流程优化新增字段
    // 招募业务筛选项
    filterOptions: {
      ...DEFAULT_FILTER_OPTIONS,
    },
    bizInfo: {
      recruiting_list: [],
      finished_list: [],
    },
  },

  effects: {
    *postApply({ payload, callback }, { call, put }) {
      // sessionStorage.setItem('RecruitApplyParms', JSON.stringify(payload));
      yield put({
        type: 'save',
        payload: {
          applyParms: payload,
        },
      });
      const res = yield call(postApply, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'save',
          payload: {
            applyResInfo: res.data,
          },
        });
        callback && callback(res);
      }
    },

    *postReApply({ payload, callback }, { call, put }) {
      const res = yield call(postReApply, payload);
      callback && callback(res);
    },

    *getApplyResult({ payload, callback }, { call, put }) {
      const res = yield call(getApplyResult, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'saveApplyResultList',
          payload: {
            applyResList: res?.data?.list || [],
            page: payload.page,
          },
        });
        callback && callback();
      }
    },

    *getFilter({ payload, callback }, { call, put }) {
      const res = yield call(getFilter, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'save',
          payload: {
            applyFilter: res.data,
          },
        });
        // callback && callback(res);
      }
    },

    *getResultFilter({ payload }, { call, put }) {
      const res = yield call(getResultFilter, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'save',
          payload: {
            resultFilter: res.data?.bizIdList || [],
          },
        });
      }
    },

    *getRecruitList({ payload, callback }, { call, put }) {
      const res = yield call(getRecruitList, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'saveDeviceList',
          payload: {
            deviceList: res.data.devicelist,
            page: payload.page,
          },
        });
        callback && callback();
      }
    },
    *getRecruitBizRules({ payload, callback }, { call, put }) {
      const res = yield call(getRecruitBizRules, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'save',
          payload: {
            bizRule: res.data,
          },
        });
        callback && callback();
      }
    },

    *setBizTabRead({ payload, callback }, { call, put }) {
      const res = yield call(setBizTabRead, payload);
      if (res?.iRet === 0) {
        // callback && callback();
        const { bizId } = payload;
        yield put({ type: 'updateTab', payload: bizId });
      }
    },

    *getRecruitBizTabs({ payload, callback }, { call, put }) {
      const res = yield call(getRecruitBizTabs, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'save',
          payload: {
            bizTabs: res.data,
          },
        });
        callback && callback();
      }
    },
    // x86上机流程优化新增操作
    *getBizFilterOptions({ payload }, { call, put }) {
      const res = yield call(getBizFilterOptions, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'saveFilterOptions',
          payload: {
            data: res.data || {},
            fromIndex: payload?.fromIndex || ''
          } ,
        });
        // callback && callback();
        Toast.hide();
        return res.data
      }
    },
    *getBizInfoList({ payload, callback }, { call, put }) {
      const res = yield call(getBizInfoList, payload);
      if (res?.iRet === 0) {
        const { data } = res;
        yield put({
          type: 'save',
          payload: {
            bizInfo: data,
          },
        });
        if (data.is_exist) {
          Toast.hide();
        } else {
          Toast.info('暂无匹配的定向业务！看看其他在招业务吧~', 3);
        }
        callback && callback();
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    updateTab(state, { payload }) {
      const curBizList = state.bizInfo?.recruiting_list || [];
      const curTabItem = curBizList.find(item => item.biz_id === payload);
      // console.log('curTabItem: ', curTabItem);
      curTabItem.new_change = false;
      return {
        ...state,
        bizInfo: {
          ...state.bizInfo,
          recruiting_list: [...curBizList],
        },
      };
    },
    saveApplyResultList(state, { payload }) {
      const { applyResList: oldList } = state;
      const { applyResList, page } = payload;
      const isFirstPage = page === 1;
      return {
        ...state,
        applyResList: isFirstPage ? [...applyResList] : [...oldList, ...applyResList],
        isResultListAll: applyResList.length < PAGE_SIZE,
      };
    },
    saveFilterOptions(state, { payload }) {
      const { nat_type = NAT_OPTIONS, ...otherOptions } = payload.data;
      const {
        filterOptions: { more },
      } = state;
      // 对请求结果进行筛选，页面只保留X86/小盒子的选项
      switch (payload?.fromIndex) {
        case X86_INDEX_TAG:
          otherOptions.device_type = otherOptions.device_type.filter(function (item) {
            return item.label === X86_INDEX_TAG;
          })
          break
        case BOX_INDEX_TAG:
          otherOptions.device_type = otherOptions.device_type.filter(function (item) {
            return item.label !== X86_INDEX_TAG;
          })
          break
        default:
          break
      }

      return {
        ...state,
        filterOptions: {
          ...otherOptions,
          more: [
            {
              id: DISPATCH_RANGE,
              title: '业务特性',
              type: LIST_MODE,
              data: DISPATCH_RANGE_OPTIONS,
              unit: '',
            },
            {
              id: NAT_TYPE,
              title: 'NAT类型',
              type: LIST_MODE,
              data: nat_type,
              unit: '',
            },
            ...more.filter(el => el.id !== NAT_TYPE && el.id !== DISPATCH_RANGE),
          ],
        },
      };
    },
    saveDeviceList(state, { payload }) {
      const { deviceList: oldList, chooseCount: oldCount } = state;
      const { deviceList, page } = payload;
      const isFirstPage = page === 1;
      return {
        ...state,
        deviceList: isFirstPage ? [...deviceList] : [...oldList, ...deviceList],
        chooseCount: isFirstPage ? 0 : oldCount,
        isCheckAll: false,
        isDeviceListAll: deviceList?.length < PAGE_SIZE,
      };
    },
    updateOneDevice(state, { payload }) {
      const { deviceList: oldList, chooseCount: oldCount } = state;
      const { index } = payload;
      const tag = !oldList[index].checked;
      oldList[index].checked = tag;
      const isCheckAll = oldList.some(e => !e.checked);
      return {
        ...state,
        deviceList: [...oldList],
        chooseCount: tag ? oldCount + 1 : oldCount < 1 ? 0 : oldCount - 1,
        isCheckAll: !isCheckAll,
      };
    },
    updateDeviceList(state, { payload }) {
      const { deviceList: oldList, isCheckAll: oldCheckAll } = state;
      const tag = !oldCheckAll;
      oldList.forEach(e => (e.checked = tag));
      return {
        ...state,
        deviceList: [...oldList],
        chooseCount: tag ? oldList.length : 0,
        isCheckAll: tag,
      };
    },
  },
};
